
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";

const AddDepart = ({ item,onAddDepart  }) => {
    const [formData, setFormData] = useState({
        cat_id:'',
        cat_name: '',
        cat_image: '',
        cat_type: 'service',
        cat_type1: '',
        cat_type2: '',
        cat_status: '',
        par_cat_id:'',
        par_by:'',
        alertMsg: '',
        alertMsgTyp: '',
        isAlert: false,
      });
      const [ldata, setLdata] = useState(null);

      const handleChange = (e) => {
       
        const { name, value } = e.target;
        setFormData(prev => ({
          ...prev,
          [name]: value
        }));
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        // alert(formData.email+"");
        const fd = new FormData();
        fd.append('cat_id', formData.cat_id);
        fd.append('cat_name', formData.cat_name);
        fd.append('cat_type', formData.cat_type);
        fd.append('cat_type1', formData.cat_type1);
        fd.append('cat_type2', formData.cat_type2);
        fd.append('cat_status', formData.cat_status);
        fd.append('par_cat_id', formData.par_cat_id);
        fd.append('par_by', ldata.user_id);
        
        try {
            const response = await axios.post(AppConst.BASE_URL+AppConst.addCatUrl, fd, {
                headers: {
                'Content-Type': 'multipart/form-data',
                },
            });

            if(response.data.status){
                setFormData(prev => ({
                ...prev,
                cat_id:'',
                cat_name: '',
                cat_image: '',
                cat_type: 'service',
                cat_type1: '',
                cat_type2: '',
                cat_status: '',
                par_cat_id:'',
                par_by:'',
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
                  document.getElementById("closeBt45").click();
                  onAddDepart();
            }
            else{
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
              }));
        }
        
      };

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
        }  

        if (item) {
            console.log("Editing item:", item);
            if(item!=null && item!=undefined){
                setFormData(prev => ({
                    ...prev,
                    cat_id:item.cat_id,
                    cat_name:item.cat_name,
                    cat_type: item.cat_type,
                    cat_type1: item.cat_type1,
                    cat_type2: item.cat_type2,
                    cat_status: item.cat_status,
                    par_cat_id: item.par_cat_id,
                    par_by: item.par_by,
                  }));
                }
          }
          else{
            setFormData(prev => ({
                ...prev,
                cat_id:'',
                cat_name: '',
                cat_image: '',
                cat_type: 'service',
                cat_type1: '',
                cat_type2: '',
                cat_status: '',
                par_cat_id:'',
                par_by:'',
              }));
          }
          
        return () => {
          console.log('Component unmounted');
        };
      }, [item]);

    return (
        <div class="modal fade" id="showModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                   <div class="modal-header bg-light p-3 d-flex justify-content-between align-items-center">
                        <h5 class="modal-title" id="exampleModalLabel">Add Services</h5>
                        
                            <button type="button" class="btn btn-sm btn-outline-primary d-inline-flex align-items-center edit-item-btn" data-bs-dismiss="modal" id="close-modal">
                            Close
                            </button>

                    </div>
                    <form class="tablelist-form" onSubmit={handleSubmit}>
                        <div class="modal-body">
                            <input id="id-field" type="hidden" />
                            
                            <div class="row gy-4 mb-3">
                           
                           <div class="col-md-12">
                               <div >
                                   <label for="customername-field" class="form-label">Service Name</label>
                                   <input name="cat_name" onChange={handleChange} value={formData.cat_name} class="form-control" placeholder="Enter Service Name" type="text" required/>
                               </div>
                           </div>
                           <div class="col-md-12">
                               <div >
                                   <label for="customername-field" class="form-label">Service Price</label>
                                   <input name="cat_type1" onChange={handleChange} value={formData.cat_type1} class="form-control" placeholder="Enter Service Price" type="text" required/>
                               </div>
                           </div>
                           <div class="col-md-12">
                               <div >
                                   <label for="customername-field" class="form-label">Description</label>
                                   <textarea name="cat_type2" onChange={handleChange} value={formData.cat_type2} class="form-control" 
                                   placeholder="Enter Description..." ></textarea>
                               </div>
                           </div>
                       </div>
                        </div>
                        <div class="modal-footer">
                            <div class="hstack gap-2 justify-content-end">
                                <button type="button" id="closeBt45" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                                {(formData.cat_id.length>0)?<button type="submit" class="btn btn-success" id="edit-btn">Update</button>:<button type="submit" class="btn btn-success" id="edit-btn">Add</button>}
                                
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddDepart;
